module.exports = __webpack_public_path__ + "img/stonks.d2cc2a4e.png";